import httpClient from '../../HttpClient';
import HttpWebPlatformAdapter from './HttpWebPlatformAdapter';
import MockWebPlatformAdapter from './MockWebPlatformAdapter'; // todo, find an abstraction solution to not deploy this in production. https://stackoverflow.com/q/71482650/4840661

const webPlatformAdapterBuilder = (keycloakIDPAdapter, apiUrl) => {
  if (apiUrl === 'mock') {
    return new MockWebPlatformAdapter();
  }
  return new HttpWebPlatformAdapter(keycloakIDPAdapter, httpClient, apiUrl);
};
export default webPlatformAdapterBuilder;